export enum OrderType {
  Asc = 'asc',
  Desc = 'desc',
}
